export const updateEntry = <T>(list: T[], update: Partial<T>, index: number): T[] => {
    const newList = [...list];
    newList[index] = { ...list[index], ...update };
    return newList;
};
